import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { hideModal } from '../../../../actions/modal';
import { updateGeogebra } from '../../../../actions/homework';
import { exercisePropTypes } from '../../../../constants/exercise';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';

export const Message = styled.span``;

export const ResetGeogebraModalBody = ({ exerciseId, exercises, onClose, updateGeogebra }) => {
    const onConfirm = () => {
        updateGeogebra(exercises[exerciseId].id, null);
        onClose();
    };
    return (
        <Modal title="Vuoi ripristinare l'originale?" onClose={onClose}>
            <ModalBodyContainer>
                <Content>
                    <Message className="body-3">{'Se ripristini la figura originale le modifiche effettuate saranno perse.'}</Message>
                </Content>
                <Buttons
                    primaryButtonClick={onConfirm}
                    primaryButtonText="Ripristina originale"
                    tertiaryButtonClick={onClose}
                    tertiaryButtonText="Mantieni modifiche"
                />
            </ModalBodyContainer>
        </Modal>
    );
};

ResetGeogebraModalBody.propTypes = {
    exerciseId: PropTypes.number,
    exercises: PropTypes.arrayOf(PropTypes.shape(exercisePropTypes)),
    onClose: PropTypes.func,
    updateGeogebra: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        exerciseId: state.status.currentExerciseIndex,
        exercises: state.homework.exercises,
    };
};

const actionCreators = {
    onClose: hideModal,
    updateGeogebra: updateGeogebra,
};

export default connect(mapStateToProps, actionCreators)(ResetGeogebraModalBody);
